import {createAsyncThunk} from "@reduxjs/toolkit";
import {USER_LOCALSTORAGE_KEY} from "../../../../../shared/const/localstorage";
import axios from "axios";
import {ActsResponse} from "../../../types/payments/actsSchema";
import {setActs} from "../../../slice/payments/actsSlice";

interface ActsParams {
    period?: string;
    page?: number;
}

export const fetchActs = createAsyncThunk(
    "payments/payments",
    async ({period, page}: ActsParams, thunkAPI) => {
        try {
            const authToken = localStorage.getItem(USER_LOCALSTORAGE_KEY);
            if (!authToken) {
                throw new Error('No token found in localStorage.');
            }
            const {token} = JSON.parse(authToken);


            const params: { period?: string; page?: string } = {};

            if (period) {
                params.period = period;
            }
            if (page) {
                params.page = page.toString();
            }

            const response = await axios.get<ActsResponse>("/api/payments/acts", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
                params,
            });

            if (!response.data) {
                throw new Error("Response data is empty");
            }

            if (response.data.success) {
                thunkAPI.dispatch(setActs(response.data.data));
            }

            return response.data;
        } catch (e) {
            return thunkAPI.rejectWithValue("error");
        }
    }
);
